const deprecationWarning = (componentName: string, message: string) => {
	// console.warn(new DeprecationWarning(`WARNING: @egalite/ui - ${componentName}: ${message}`));
};

export default deprecationWarning;
